module.exports = __webpack_public_path__ + "img/logo1.078a9934.png";